import { render } from "./MCheckbox.vue?vue&type=template&id=0804a35b&scoped=true"
import script from "./MCheckbox.vue?vue&type=script&lang=js"
export * from "./MCheckbox.vue?vue&type=script&lang=js"

import "./MCheckbox.vue?vue&type=style&index=0&id=0804a35b&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0804a35b"]])

export default __exports__